(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CovidIndividualDetailController', CovidIndividualDetailController);

    CovidIndividualDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CovidIndividual', 'CovidSignature'];

    function CovidIndividualDetailController($scope, $rootScope, $stateParams, previousState, entity, CovidIndividual, CovidSignature) {
        var vm = this;

        vm.covidIndividual = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bluebookApp:covidIndividualUpdate', function(event, result) {
            vm.covidIndividual = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
